
export const clientInfoSchema = {
	title: "Form Submission Details",
	type: "object",
	required: ["formSubmissionDetails", "clientInformation"],
	properties: {
		formSubmissionDetails: {
			type: "object",
			title: "Form Submission Details",
			description: "Let us know who is filling out this form",
			required: [
				"city",
				"communityLiaison",
				"isFillingForSomeoneElse",
				"email",
				"referralSource",
				"fillersFirstName",
				"fillersLastName",
				"fillersPhone",
			],
			properties: {
				city: {
					type: "string",
					title: "Select location",
					minLength: 1,
					errorMessage: {
						required: "Please select a location",
						minLength: "Please select a location",

					},
				},
				communityLiaison: {
					type: "string",
					title: "Select Community Liaison",
					minLength: 1,
					errorMessage: {
						required: "Please select a community liaison",
						minLength: "Please select a community liaison",
					},
				},
				isFillingForSomeoneElse: {
					type: "string",
					title: "Are you filling out this form for someone else?",
					enum: ["Yes", "No"],
					errorMessage: {
						required: "Please select an answer",
					},
				},
				fillerIdentity: {
					type: "string",
					title: "Who is filling out this form?",
					enum: ["Spouse", "Family", "Legal Representative", "Other"],
					errorMessage: {
						required: "Please select who is filling out this form",
					},
				},
				fillersFirstName: {
					type: "string",
					title: "Filler's First Name",
					maxLength: 25,
					errorMessage: {
						required: "Filler's first name is required",
						maxLength: "Filler's first name must be at most 25 characters",
					}
				},
				fillersLastName: {
					type: "string",
					title: "Filler's Last Name",
					maxLength: 25,
					errorMessage: {
						required: "Filler's last name is required",
						maxLength: "Filler's last name must be at most 25 characters",
					},
				},
				fillersPhone: {
					type: "string",
					title: "Filler's Phone",
					pattern: "^\\(\\d{3}\\) \\d{3}-\\d{4}$",

					errorMessage: {
						required: "Filler's phone is required",
						pattern: "Enter a valid phone number in format (xxx) xxx-xxxx",

					},
				},
				email: {
					type: "string",
					format: "email",
					title: "Email Address",
					maxLength: 85,
					errorMessage: {
						required: "Please enter a valid email address",
						format: "Please enter a valid email address",
						maxLength: "Email must be under 85 characters",
					},
				},
				referralSource: {
					type: "string",
					title: "Please list who referred you to Cambridge Caregivers",
					minLength: 1,
					errorMessage: {
						required: "Please enter who referred you",
						minLength: "Please enter who referred you",
					},
				},
			},
			dependencies: {
				isFillingForSomeoneElse: {
					oneOf: [
						{
							properties: {
								isFillingForSomeoneElse: { const: "Yes" },
								fillerIdentity: {
									type: "string",
									title: "Who is filling out this form?",
									enum: ["Spouse", "Family", "Legal Representative", "Other"],
									minLength: 1,
									errorMessage: {
										required: "Please select who is filling out this form",
										minLength: "Please select who is filling out this form",
									},
								},
							},
							required: ["fillerIdentity"],
						},
						{
							properties: {
								isFillingForSomeoneElse: { const: "No" },
								fillerIdentity: {
									type: "string",
									title: "Who is filling out this form?",
									enum: ["Spouse", "Family", "Legal Representative", "Other"],
								},
							},
						},
					],
				},
			},
		},
		clientInformation: {
			type: "object",
			title: "Client Information",
			description: "Enter the basic details about the client who needs care",
			required: [
				"firstName",
				"lastName",
				"dateOfBirth",
				"gender",
				"heightFeet",
				"heightInches",
				"weight",
			],
			properties: {
				firstName: {
					type: "string",
					title: "First Name",
					maxLength: 25,
					errorMessage: {
						required: "First name is required",
						maxLength: "First name must be at most 25 characters",
					}
				},
				lastName: {
					type: "string",
					title: "Last Name",
					maxLength: 25,
					errorMessage: {
						required: "Last name is required",
						maxLength: "Last name must be at most 25 characters",
					},
				},
				dateOfBirth: {
					type: "string",
					title: "Date of Birth (MM/DD/YYYY)",
					errorMessage: {
						required: "Date of Birth is required",
					},
				},
				gender: {
					type: "string",
					title: "Gender",
					enum: ["Male", "Female"],
					errorMessage: {
						required: "Please select a gender",
					},
				},
				heightFeet: {
					type: "number",
					title: "Height (Feet)",
					minimum: 0,
					maximum: 9,
					multipleOf: 1,
					errorMessage: {
						required: "Height(Feet) must be between 0 to 9",
						minimum: "Height(Feet) must be between 0 to 9",
						multipleOf: "Height (Feet) must be a whole number without decimals.",
						maximum: "Height(Feet) must be between 0 to 9",
					},
				},
				heightInches: {
					type: "number",
					title: "Height (Inches)",
					minimum: 0,
					maximum: 12,
					multipleOf: 1,
					errorMessage: {
						required: "Height (Inches) must be between 0 to 12",
						minimum: "Height (Inches) must be between 0 to 12",
						multipleOf: "Height (Inches) must be a whole number without decimals.",
						maximum: "Height (Inches) must be between 0 to 12",
					},
				},
				weight: {
					type: "number",
					title: "Weight (lbs)",
					minimum: 1,
					maximum: 700,
					multipleOf: 0.01,
					errorMessage: {
						required: "Weight must be between 1 to 700",
						minimum: "Weight must be between 1 to 700",
						maximum: "Weight must not exceed 700 lbs",
						multipleOf: "Weight must have no more than 2 decimal places",

					},
				},

			},
		},
	},
};

export const clientInfoUiSchema = {
	formSubmissionDetails: {
		city: {
			"ui:md": 6, "ui:field": "CityField", "ui:options": {
				label: "Select location"
			},
		},
		communityLiaison: {
			"ui:md": 6, "ui:field": "CommunityLiaisonField"
			, "ui:options": {
			},
		},
		isFillingForSomeoneElse: { "ui:md": 6 },
		fillerIdentity: {
			"ui:widget": "RelationshipSelect", "ui:md": 6,
			"ui:options": {
				disabled: {
					path: "formSubmissionDetails.isFillingForSomeoneElse",
					value: "No",
				},
				dependDisabled:true,
				hideError: false,
			},
		},
		email: { "ui:md": 6 },
		referralSource: { "ui:md": 6 },
		fillersFirstName: { "ui:md": 6 },
		fillersLastName: { "ui:md": 6 },
		fillersPhone: {
			"ui:md": 6, "ui:widget": "PhoneWidget", "ui:options": {
				inputType: "tel",
				disabled: false,
				readonly: false,
				hideError: false,
			},
		},
	},
	clientInformation: {
		"ui:options": {
			showErrorList: true,
		},
		firstName: { "ui:md": 6 },
		lastName: { "ui:md": 6 },
		dateOfBirth: {
			"ui:md": 6,
			"ui:widget": "DateWidget",
			"ui:options": {
				isDateOfBirth: true
			}
		},
		gender: {
			"ui:md": 6,
			"ui:widget": "select",
			"ui:options": {
				disableDefault: true
			}
		},
		heightFeet: {
			"ui:md": 6, "ui:widget": "NumberWidget",
			"ui:options": {
				hideError: false,
				inputMode: "numeric",
				step: 1,
				min: 0,
				max: 9
			}
		},
		heightInches: {
			"ui:md": 6, "ui:widget": "NumberWidget",
			"ui:options": {
				hideError: false,
				inputMode: "numeric",
				step: 1,
				min: 0,
				max: 12
			}
		},
		weight: {
			"ui:md": 6, "ui:widget": "NumberWidget",
			"ui:options": {
				hideError: false,
				inputMode: "decimal",
				min: 0,
				step: 1,
				max: 700
			}
		},
	},
};